module.exports = __webpack_public_path__ + "img/flow_4.cc719411.png";